import CustomerLoyalty from "@/components/management/components/customer/CustomerLoyalty";
import AddPromotion from "@/components/management/components/menu/AddPromotion";
import EditPromotion from "@/components/management/components/menu/EditPromotion";
import Promotion from "@/components/management/components/menu/Promotion";

const LoyaltyRoutes = [
  { path: "/loyalty", element: <CustomerLoyalty /> },
  { path: "/promotions", element: <Promotion /> },
  { path: "/promotions/add", element: <AddPromotion /> },
  { path: "/promotions/edit/:id", element: <EditPromotion /> },
];

export default LoyaltyRoutes;
